import React from 'react'
import PropTypes from 'prop-types'

// Components
import { Player } from 'src/Components/shared/Player'

// Styles
import styles from './RefiDetailsVideo.module.scss'

const RefiVideo = ({ videoId, videoType }) => {
  return (
    <div className={styles.video} data-qa='video'>
      <Player
        className={styles.video}
        videoType={videoType}
        videoId={videoId}
      />
    </div>
  )
}
RefiVideo.propTypes = {
  videoId: PropTypes.string,
  videoType: PropTypes.string
}

export default RefiVideo
